import { PageShell } from "@/components/PageShell";
import { Calculator } from "@/components/Calculator";

export default function CalculatorsPage() {
  return (
    <PageShell>
      <Calculator />
    </PageShell>
  );
}
